'use client'
import { storyblokEditable } from '@storyblok/react/rsc'
import { FC } from 'react'

import { PhnxForminput } from '@/components/01-atoms/Forminput/Forminput'
import { PhnxFormselect } from '@/components/01-atoms/Formselect/Formselect'
import { PhnxFormtoggle } from '@/components/01-atoms/Formtoggle/Formtoggle'
import FormRow from '@/components/02-molecules/FormRow/Blok'

import { PhnxForm } from './Form'

interface FormBlokProps {
  blok: any
  uuid: string
}

export const renderField = (field: any) => {
  if (field === undefined) return null
  const component = Array.isArray(field) ? field[0].component : field.component

  const phoneEnquiryOptions =
    component === 'formSelect'
      ? [{ Business: field.phoneEnquiryBusiness }, { Personal: field.phoneEnquiryPersonal }]
      : []

  switch (component) {
    case 'formInput':
      return (
        <PhnxForminput
          variant={field.variant}
          lineHeight={field.lineHeight}
          name={field.name}
          label={field.label}
          placeholder={field.placeholder}
          hiddenValue={field.hiddenValue}
          isRequired={field.required}
          showRequired={field.showRequired}
          radioOptions={field.radioOptions}
          customAnswer={field.customField_answer}
        />
      )
    case 'formToggle':
      return (
        <PhnxFormtoggle
          name={field.name}
          label={field.label}
          isRequired={field.required}
          showRequired={field.showRequired}
          option1label={field.option1Label}
          option1value={field.option1Value}
          option2label={field.option2Label}
          option2value={field.option2Value}
        />
      )
    case 'formSelect':
      return (
        <PhnxFormselect
          variant={field.variant}
          name={field.name}
          label={field.label}
          options={field.options}
          multiOptions={field.multiOptions}
          isRequired={field.required}
          showRequired={field.showRequired}
          phoneEnquiryOptions={phoneEnquiryOptions}
        />
      )
    case 'formRow':
      return <FormRow blok={field} />
    default:
      return <div>Field not found</div>
  }
}

const Form: FC<FormBlokProps> = ({ blok, uuid }) => {
  return (
    <div id={blok.formID} {...storyblokEditable(blok)}>
      <PhnxForm
        title={blok.title}
        description={blok.description}
        content={blok.content}
        subContent={blok.subContent}
        disclaimer={blok.disclaimer}
        disclaimer_align={blok.disclaimer_align}
        fields={blok.fields && blok.fields.map((field: any) => renderField(field))}
        uuid={uuid}
        country={blok.country}
        lead_source={blok.lead_source}
        campaign_id={blok.campaign_id}
        lead_type={blok.lead_type}
        submission_url={blok.submission_url}
        isSubscribeForm={blok.isSubscribeForm}
        backgroundColor={blok.form_color}
        textColor={blok.textColour || 'white'}
        ctaLabel={blok.cta_label}
        ctaVariant={blok.cta_variant}
        ctaFullMobile={blok.cta_full_mobile}
        ctaPosition={blok.cta_position}
        ctaBold={blok.cta_bold}
        padding={blok.padding}
        alignment={blok.align_content}
        endpoint={blok.endpoint}
        variant={blok.variant}
        shadow={blok.shadow}
        border={blok.border}
        accessCookie={blok.set_access_cookie}
        formID={blok.formID}
      />
    </div>
  )
}

export default Form
